// types
export interface ServiceItem {
  name: string;
  path: string;
}

export interface ServiceCategory {
  title: string;
  items: ServiceItem[];
}

// data
export const servicesMenu: ServiceCategory[] = [
  {
    title: "Regulatory Services",
    items: [
      { name: "Strategic Regulatory Planning", path: "/regulatory-services/strategic-regulatory-planning" },
      { name: "Comprehensive eCTD & SPL Publishing Services", path: "/regulatory-services/comprehensive-ectd-spl" },
      { name: "Global Drug Master File (DMF) Classification", path: "/regulatory-services/global-drug-master-file-dmf" },
      { name: "Dossier Management", path: "/regulatory-services/dossier-management" },
      { name: "Regulatory Representation Services", path: "/regulatory-services/regulatory-representation-services" },
      { name: "Regulatory Support Services", path: "/regulatory-services/regulatory-support-services" },
    ],
  },
  {
    title: "GMP Audits & Compliance",
    items: [
      { name: "GMP Audits Compliance & Training Services", path: "/gmp-audits-and-compliance/gmp-audits-compliance-and-training-services" },
    ],
  },
  {
    title: "IT Solutions for Pharma",
    items: [
      { name: "Enterprise Quality Management System (EQMS)", path: "/it-solutions-for-pharma/enterprise-quality-management-system-eqms" },
      { name: "eCTD Publishing Software", path: "/it-solutions-for-pharma/ectd-publishing-software" },
      { name: "Pharmacovigilance & Drug Safety Software", path: "/it-solutions-for-pharma/pharmacovigilance-and-drug-safety-software" },
      { name: "Clinical Trial Management Platform", path: "/it-solutions-for-pharma/clinical-trial-management-platform" },
    ],
  },
  {
    title: "Pharma Project Management",
    items: [
      { name: "Product Development – API & Formulations", path: "/pharma-project-management/product-development-api-and-formulations" },
      { name: "Analytical Development & Microbiology Services", path: "/pharma-project-management/analytical-development-and-microbiology-services" },
      { name: "Business Development Services", path: "/pharma-project-management/business-development-services" },
    ],
  },
  {
    title: "Trainings",
    items: [
      { name: "Regulatory Training Programs", path: "/trainings/regulatory-training-programs" },
      { name: "GMP Training Programs", path: "/trainings/gmp-training-programs" },
      { name: "Corporate Training & Professional Development", path: "/trainings/corporate-training-and-professional-development" },
    ],
  },
  {
    title: "Product Development & Analytical Solutions",
    items: [
      { name: "Integrated Analytical & Product Characterization Services", path: "/product-development-and-analytical-solutions/integrated-analytical-and-product-characterization-services" },
      { name: "Product Development & Analytical Solutions", path: "/product-development-and-analytical-solutions/product-development-and-analytical-solutions" },
    ],
  },
];
